import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  PaginationResult,
} from '@ckmk/angular';
import {
  PostFetchAllPayload,
  PostsResult,
} from '@app/src/app/modules/post/types/types';
import { TypedDocumentNode } from '@apollo/client';
import { PostModel } from '@app/src/app/modules/post/classes/default/model/post.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class PostsRequestQuery extends AbstractGraphqlRequest<
  PostsResult,
  { payload: PostFetchAllPayload }
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findAllPosts($payload: PostRequestPayloadInput) {
        findAllPosts(payload: $payload) {
          pagination {
            hasNext
            hasPrevious
            limit
            page
            total
            totalPage
          }
          result {
            id
            category {
              id
              title
              description
              slug
            }
            cover {
              id
              name
              extension
              directory
              directories
              frontUrls
              mimetype
            }
            picture {
              id
              name
              extension
              directory
              directories
              frontUrls
              mimetype
            }
            pictures {
              id
              name
              extension
              directory
              directories
              frontUrls
              mimetype
            }
            slug
            title
            description
            shortDescription
            active
            createdAt
            updatedAt
            deletedAt
            createdBy
            updatedBy
          }
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let { pagination, result } = data.findAllPosts;

    if (pagination) {
      pagination = new PaginationResult(pagination);
    }

    result = result.map((grp: any) => new PostModel(grp));

    return { result, pagination };
  }
}
